module.exports = __webpack_public_path__ + "static/img/androidcode.38a903c4.png";